import { PKG } from '../../analytics/analyticsConsts';
import { generateNewUUID, prompt, showError } from '../../api/api';
import { loadHome } from '../../api/loadHome/loadHome';
import { setDeviceID } from '../../app/apiScreenSlice';
import { setAuth } from '../../app/consumerInfoSlice';
import { setMultiCardUser } from '../../app/loginSlice';
import { setProductUUID } from '../../app/merchantDataSlice';
import { AppDispatch, RootState } from '../../app/store';
import { handleLoadHomeSuccess } from '../../components/pinEntry/loadHomeHandlers';
import { ANALYTICS } from '../../firebase/firebase';
import { COOKIEKEY } from '../../utils/cookieConstants';
import {
  getCookieValueFor,
  reApplicationSetUpAfterHome,
  reApplicationSetUpAfterPrompt,
  removeCookieFor,
} from '../../utils/functionUtils';

export const handleRedirectedFromServicing = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const isReApplication = getCookieValueFor(COOKIEKEY.REAPPLICATION);
    if (isReApplication !== 'true') {
      return;
    }

    const auth = getState().consumerInfoSelector.auth;
    const tokenCookie = getCookieValueFor(COOKIEKEY.JWT);
    const productUUID = getCookieValueFor(COOKIEKEY.PRODUCT_UUID);
    const isMultiCard = getCookieValueFor(COOKIEKEY.ISMULTICARD);

    if (getCookieValueFor(COOKIEKEY.DEVICEID) !== undefined) {
      dispatch(setDeviceID(getCookieValueFor(COOKIEKEY.DEVICEID)));
    } else {
      dispatch(setDeviceID(generateNewUUID()));
    }

    removeCookieFor(COOKIEKEY.JWT);
    removeCookieFor(COOKIEKEY.DEVICEID);
    removeCookieFor(COOKIEKEY.PRODUCT_UUID);
    removeCookieFor(COOKIEKEY.ISMULTICARD);
    removeCookieFor(COOKIEKEY.REAPPLICATION);

    dispatch(
      setAuth({
        ...auth,
        token: tokenCookie,
        lastActive: new Date().toString(),
      })
    );
    dispatch(setProductUUID(productUUID));

    if (isMultiCard === 'true') {
      dispatch(setMultiCardUser(true));
      loadHome({
        onSuccess: () => {
          handleLoadHomeSuccess({
            isReapplication: true,
          });
          reApplicationSetUpAfterHome(dispatch);
        },
      });
    } else {
      const productUUID = getState().merchantDataSelector.productUUID;
      const deviceID = getState().apiScreenScreenSelector.deviceID;
      const [promptData] = await prompt({
        productUUID,
        deviceID,
      });

      if (!promptData) {
        showError(dispatch);
        ANALYTICS.funcError(
          PKG,
          're-application prompt',
          'missing prompt data'
        );
        return null;
      }
      reApplicationSetUpAfterPrompt(promptData, dispatch, getState);
    }
    return;
  };
};
